import './_contact-us-block.scss';
import { AnalyticsService } from '../../typescript/common/analytics-service';

(function contactUsBlock() {
  const customerServiceLinks: NodeListOf<HTMLAnchorElement> = document.querySelectorAll('[data-component="contact-us-customer-service-link"]');

  if (customerServiceLinks && customerServiceLinks.length > 0) {
    class ContactUsBlock {
      public init() {
        this.trackCustomerServiceLinks();
      }

      private trackCustomerServiceLinks() {
        if (!customerServiceLinks) {
          return;
        }

        customerServiceLinks.forEach((link) => {
          link.addEventListener('click', () => {
            if (link.innerText) {
              AnalyticsService.addEvent(AnalyticsService.ContactUsCategory, 'Till Kundservice');
            }
          });
        });
      }
    }
    const component = new ContactUsBlock();
    component.init();
  }
})();
